import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _RegexComponent;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { toErrors } from '../../../../../../util/instUIMessages';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { TextInput, withStyleOverrides } from '@instructure/quiz-common';
var RegexComponent = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_RegexComponent = /*#__PURE__*/function (_Component) {
  function RegexComponent() {
    var _this2;
    _classCallCheck(this, RegexComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, RegexComponent, [].concat(args));
    _defineProperty(_this2, "handleRegexChange", function (e) {
      var scoringData = {
        value: e.target.value,
        blankText: _this2.props.scoringDataForBlank.blankText
      };
      _this2.props.updateScoringDataForBlank({
        scoringData: scoringData
      });
    });
    return _this2;
  }
  _inherits(RegexComponent, _Component);
  return _createClass(RegexComponent, [{
    key: "render",
    value: function render() {
      var scoringDataForBlank = this.props.scoringDataForBlank;
      return jsx("div", {
        css: this.props.styles.optionsInput
      }, jsx(TextInput, {
        type: "text",
        messages: toErrors(this.props.errors).concat(this.props.validationErrorsFromApi),
        value: scoringDataForBlank.value,
        renderLabel: t('Regular Expression'),
        isRequired: true,
        onChange: this.handleRegexChange
      }));
    }
  }]);
}(Component), _defineProperty(_RegexComponent, "displayName", 'RegexComponent'), _defineProperty(_RegexComponent, "componentId", "Quizzes".concat(_RegexComponent.displayName)), _defineProperty(_RegexComponent, "propTypes", {
  errors: PropTypes.array,
  scoringDataForBlank: PropTypes.object,
  updateScoringDataForBlank: PropTypes.func,
  validationErrorsFromApi: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    text: PropTypes.string
  })),
  styles: PropTypes.object
}), _defineProperty(_RegexComponent, "defaultProps", {
  errors: void 0,
  scoringDataForBlank: void 0,
  updateScoringDataForBlank: void 0,
  validationErrorsFromApi: []
}), _RegexComponent)) || _class);
export { RegexComponent as default };